<script setup lang="ts">
import { ref } from 'vue'

import { api, messageFrom, setCsrfToken } from '../api'

const emit = defineEmits<{ loggedIn: [] }>()
const requested = ref(false)
const code = ref('')
const busy = ref(false)
const error = ref('')

async function requestCode(): Promise<void> {
  busy.value = true
  error.value = ''
  try {
    await api('/api/admin/auth/request-code', { method: 'POST', body: '{}' })
    requested.value = true
    code.value = ''
  } catch (reason) { error.value = messageFrom(reason) }
  finally { busy.value = false }
}

async function login(): Promise<void> {
  if (code.value.length !== 4) return
  busy.value = true
  error.value = ''
  try {
    const session = await api<{ csrfToken: string }>('/api/admin/auth/login', {
      method: 'POST', body: JSON.stringify({ code: code.value }),
    })
    setCsrfToken(session.csrfToken)
    emit('loggedIn')
  } catch (reason) { error.value = messageFrom(reason) }
  finally { busy.value = false }
}
</script>

<template>
  <main class="login-page">
    <form class="login-card" @submit.prevent="login">
      <div class="login-icon">🎭</div>
      <p class="eyebrow">Админка</p>
      <h1>Каким бы я был</h1>
      <p class="muted">Войди по одноразовому коду из Telegram или через SSO личной панели.</p>
      <template v-if="requested">
        <label for="code">Код из Telegram</label>
        <input
          id="code" v-model="code" class="code-input" inputmode="numeric" maxlength="4"
          autocomplete="one-time-code" autofocus
          @input="code = code.replace(/\D/g, '').slice(0, 4)"
        />
      </template>
      <p v-if="error" class="error">{{ error }}</p>
      <button v-if="requested" class="button button--primary" :disabled="busy || code.length !== 4">
        {{ busy ? 'Вхожу…' : 'Войти' }}
      </button>
      <button v-else class="button button--primary" type="button" :disabled="busy" @click="requestCode">
        {{ busy ? 'Отправляю…' : 'Прислать код' }}
      </button>
      <button v-if="requested" class="link-button" type="button" :disabled="busy" @click="requestCode">
        Прислать новый код
      </button>
    </form>
  </main>
</template>
